import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateRadioFormField(
  params: FormFieldGenerationParams<'radio'>,
): PartialPropsOf<'radio'> {
  let props: PartialPropsOf<'radio'> = applyPropsPatch(params.props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  if (params.inputData.column.dataType === 'Boolean') {
    props = applyPropsPatch(props, {
      content: { radio: { values: ['Yes', 'No'] } },
    });
  }

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { radio: { readonly: true } } });
  }

  return props;
}
